import {Deserializable} from "../shared/models/deserializable.model";
import { Quote } from "./quote";
import { Invoice } from "./invoice";

export class Property implements Deserializable {
   accountId: number;
   id: number;
   address1: string;
   address2: string;
   city: string;
   postcode: string;
   createdAt: string;
   updatedAt: string;
   contactId: number;
   Invoices: Invoice[];
   Quotes: Quote[];

   deserialize(input: any) {
   	//Object.assign(this, input);

     if (input.hasOwnProperty('id')) {
       this.id = input.id;
     }
     if (input.hasOwnProperty('accountId')) {
       this.accountId = input.accountId;
     }
     if (input.hasOwnProperty('address1')) {
       this.address1 = input.address1;
     }
     if (input.hasOwnProperty('address2')) {
       this.address2 = input.address2;
     }
     if (input.hasOwnProperty('city')) {
       this.city = input.city;
     }
     if (input.hasOwnProperty('postcode')) {
       this.postcode = input.postcode;
     }
     if (input.hasOwnProperty('contactId')) {
       this.contactId = input.contactId;
     }
     if (input.hasOwnProperty('createdAt')) {
       this.createdAt = input.createdAt;
     }
     if (input.hasOwnProperty('updatedAt')) {
       this.updatedAt = input.updatedAt;
     }

    if (input.hasOwnProperty('Invoices')) {
      this.Invoices = input.Invoices.map((invoice) => new Invoice().deserialize(invoice));
    }

    if (input.hasOwnProperty('Quotes')) {
      this.Quotes = input.Quotes.map((quote) => new Quote().deserialize(quote));
    }

    return this;
  }

  get oneLiner(): string {
      return this.address1+' '+this.city+' '+this.postcode;
  }

}